import React, { useEffect, useState } from "react";
import { Grid, Typography, Paper, Box, FormGroup, FormControlLabel, Checkbox, Divider, CircularProgress } from "@mui/material";
import { LoadingButton } from '@mui/lab';
import styles from './first-time-modal.module.scss';
import { ArrowCircleRight } from 'iconsax-react';

const FirstTimeModal = ({ setShow, uiStore }) => {
    const [categories, setCategories] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [loading, setLoading] = useState(false);

    const submit = async () => {
        setLoading(true);
        await uiStore.addUserCategories(selectedCategories, true);
        setShow(false);
    }

    const skip = async () => {
        setLoading(true);
        await uiStore.addUserCategories([], true);
        setShow(false);
    }

    const handleOnChange = (e, category) => {
        if (e.target.checked) {
            if (!selectedCategories.includes(category))
                setSelectedCategories([...selectedCategories, category])
        } else {
            setSelectedCategories(selectedCategories.filter(i => i !== category));
        }
    }

    useEffect(() => {
        async function fetchCategories() {
            setLoading(true);
            const data = await uiStore.getGeneralUserCategories();
            setSelectedCategories(data.filter(i => i.required).map(i => i.categoryName));
            setCategories(data);
            setLoading(false);
        }

        fetchCategories();
    }, [uiStore]);



    return (
        <Paper variant="round" sx={{ p: '50px', width: '100%', maxWidth: '780px', height: 'fit-content', mt: 3 }}>
            <Grid container>
                <Grid item xl={8} lg={8} md={8} sm={12}>
                    <Typography variant="h5" fontWeight='700'>Select Information</Typography>
                    <Typography color='#888888' sx={{ mt: 1 }}>Choose the data you will add to start making your cards</Typography>
                    <Box>
                        <FormGroup sx={{ m: 2, display: 'flex', flexDirection: 'row' }}>
                            {categories.map(item =>
                                <FormControlLabel
                                    className={styles.dataDialougeCheckBox}
                                    key={item._id}
                                    control={
                                        <Checkbox />
                                    }
                                    label={<Typography fontSize='14px' fontWeight={500}>{item.categoryName}</Typography>}
                                    onChange={(e) => handleOnChange(e, item.categoryName)}
                                    disabled={item.mandatory}
                                    checked={!!selectedCategories.includes(item.categoryName)}
                                />
                            )}
                        </FormGroup>
                    </Box>
                </Grid>
                <Grid item xl={4} lg={4} md={4} display={{ md: 'block', sm: 'none', xs: 'none' }} className={styles.dataImg}>
                </Grid>
            </Grid>
            <Divider></Divider>
            <Box sx={{ mt: 3 }} className={styles.dataDialougeActions}>
                {!loading ? <>
                    <LoadingButton loading={!!loading} onClick={skip} variant="contained" color="lightblue">Skip</LoadingButton>
                    <LoadingButton loading={!!loading} onClick={submit} variant="contained" color="primary" endIcon={<ArrowCircleRight
                        size="24"
                        variant="Bulk"
                    />}>
                        Select
                    </LoadingButton>
                </>
                    :
                    <CircularProgress />
                }
            </Box>
        </Paper>
    );
};

export default FirstTimeModal;